import React, { useRef, useEffect, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './VerticalProgress.css';

gsap.registerPlugin(ScrollTrigger);

export default function VerticalProgress() {
  const trackRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    const parent = el.parentElement;
    if (!parent) return;

    const ctx = gsap.context(() => {
      ScrollTrigger.create({
        trigger: parent,
        start: 'top bottom',
        end: 'bottom top',
        onToggle: (self) => setVisible(self.isActive),
        onUpdate: (self) => setProgress(self.progress),
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <div ref={trackRef} className={`vertical-progress${visible ? ' vertical-progress--visible' : ''}`}>
      <div className="vertical-progress__track">
        <div className="vertical-progress__fill" style={{ height: `${progress * 100}%` }} />
        <div className="vertical-progress__dot" style={{ top: `${progress * 100}%` }} />
      </div>
    </div>
  );
}
